import { PlayerProfileTabIdentifiers } from '../../utils/constants';

const { OVERVIEW } = PlayerProfileTabIdentifiers;

// True once the loaded profile is the player the route points at. ProfilePage.componentDidUpdate can
// fire one cycle before SET_PLAYER_ID resets isProfileLoaded on a profile→profile navigation, so the
// still-true isProfileLoaded belongs to the PREVIOUS profile; gating on this keeps tab-visibility
// (isOwnProfile etc.) from being judged against that stale profile.
export const loadedProfileMatchesRoute = (profile, routePlayerId) => (
    // String-compare because the loaded playerId is numeric and the route param is a string.
    String(profile?.playerId) === String(routePlayerId)
);

// Pure decision for ProfilePage.componentDidUpdate: whether a login-gated or feature-hidden tab
// should be bounced to Overview. Only redirects once the loaded profile matches the route, so a
// valid deep link (e.g. Saved Lists ?t=8&listid=…) is never stripped on stale profile data.
export function shouldRedirectHiddenTabToOverview({
    isProfileLoaded,
    profileMatchesRoute,
    userLoggedIn,
    tabIsVisible,
    tabIdentifier,
}) {
    return !!(
        isProfileLoaded &&
        profileMatchesRoute &&
        (!userLoggedIn || !tabIsVisible) &&
        tabIdentifier !== OVERVIEW
    );
}
